<div class="event-card-wrapper">
  <div class="event-info">
    <div [style]="'border-color:' + avatarIconColorhex" class="icon-wrapper">
      <div [style]="'color:' + avatarIconColorhex" class="icon-circle">
        <!--        By putting the 'event-card-icon' attribute in the html tag you can call whatever icon you need-->
        <!--        Example: <i event-card-icon class="fas fa-sim-card"></i>-->
        <ng-content select="[event-card-icon]"></ng-content>
      </div>
    </div>
    <div>
      <div class="top-line-wrapper">
        <span class="ressource-name">
          {{ resourceName }}
        </span>
        <span class="event-name">
          {{ eventName }}
        </span>
        <span *ngIf="eventDetailsTpl" nz-typography nzType="secondary">
          <ng-container *ngTemplateOutlet="eventDetailsTpl"></ng-container>
        </span>
        <span *ngIf="eventDetailsText" nz-typography nzType="secondary">
          {{ eventDetailsText }}
        </span>
      </div>
      <div class="secondary-info">
        <span class="event-date" nz-typography nzType="secondary">{{
          eventTs | localizedDate : "h:mm a"
          }}</span>
        <span *ngIf="eventTs && requesterName" class="dot-separator"></span>
        <span nz-typography nzType="secondary">{{ requesterName }}</span>
      </div>
    </div>
  </div>

  <div>
    <div
      [ngClass]="{
        'ressource-details-inline':
          ressourceDetailTitleSecondary && ressourceDetailIdSecondary
      }"
      class="ressource-details"
    >
      <div class="ressource-details-title" nz-typography nzType="secondary">
        {{ ressourceDetailTitle }}
        <span *ngIf="ressourceDetailTitle" class="two-dots">:</span>
      </div>
      <div class="actions-wrapper">
        <app-copy-text
          *ngIf="ressourceDetailId"
          [nzColor]="'secondary'"
          [nzTheme]="'outline'"
          [textPosition]="'left'"
          [textToCopy]="ressourceDetailId"
          [textToDisplay]="ressourceDetailId"
        ></app-copy-text>
        <span
          (click)="linkClicked()"
          *ngIf="hasLinkResDetail"
          class="icon-link"
          nz-icon
          nzTheme="outline"
          nzType="link"
        ></span>
      </div>
    </div>
    <div
      *ngIf="ressourceDetailTitleSecondary && ressourceDetailIdSecondary"
      class="ressource-details ressource-details-inline"
    >
      <div class="ressource-details-title" nz-typography nzType="secondary">
        {{ ressourceDetailTitleSecondary }}
        <span *ngIf="ressourceDetailTitleSecondary" class="two-dots">:</span>
      </div>
      <div class="actions-wrapper">
        <app-copy-text
          *ngIf="ressourceDetailIdSecondary"
          [nzColor]="'secondary'"
          [nzTheme]="'outline'"
          [textPosition]="'left'"
          [textToCopy]="ressourceDetailIdSecondary"
          [textToDisplay]="ressourceDetailIdSecondary"
        ></app-copy-text>
        <span
          (click)="linkSecondaryClicked()"
          *ngIf="hasLinkResDetailSecondary"
          class="icon-link"
          nz-icon
          nzTheme="outline"
          nzType="link"
        ></span>
      </div>
    </div>
  </div>
</div>
